(function () {
  'use strict';

  var banner;
  var options;
  var customizeButton;
  var acceptButton;
  var rejectButton;
  var saveButton;
  var api;
  var storageKey = 'dailybear_cookie_choice';

  function showBanner() {
    if (!banner) return;
    banner.hidden = false;
  }

  function hideBanner() {
    if (!banner) return;
    banner.hidden = true;
  }

  function openPreferences() {
    if (!banner || !options) return;
    banner.hidden = false;
    options.hidden = false;
    customizeButton.hidden = true;
    acceptButton.hidden = true;
    rejectButton.hidden = true;
    saveButton.hidden = false;
  }

  function setCheckboxes(consent) {
    if (!consent) return;
    var preferenceInput = banner.querySelector('[data-consent-preferences]');
    var analyticsInput = banner.querySelector('[data-consent-analytics]');
    var marketingInput = banner.querySelector('[data-consent-marketing]');

    if (preferenceInput) preferenceInput.checked = consent.preferences === 'yes';
    if (analyticsInput) analyticsInput.checked = consent.analytics === 'yes';
    if (marketingInput) marketingInput.checked = consent.marketing === 'yes';
  }

  function saveConsent(consent) {
    consent.sale_of_data = false;
    try {
      localStorage.setItem(storageKey, JSON.stringify(consent));
    } catch (error) {}

    hideBanner();
    if (!api || typeof api.setTrackingConsent !== 'function') {
      return;
    }

    api.setTrackingConsent(consent, function () {});
  }

  function getFallbackConsent() {
    try {
      var stored = localStorage.getItem(storageKey);
      if (!stored) return null;
      var consent = JSON.parse(stored);
      if (
        typeof consent.preferences !== 'boolean' ||
        typeof consent.analytics !== 'boolean' ||
        typeof consent.marketing !== 'boolean'
      ) return null;
      return consent;
    } catch (error) {
      return null;
    }
  }

  function initialiseApi() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      var fallbackConsent = getFallbackConsent();
      if (fallbackConsent) setCheckboxes({
        preferences: fallbackConsent.preferences ? 'yes' : 'no',
        analytics: fallbackConsent.analytics ? 'yes' : 'no',
        marketing: fallbackConsent.marketing ? 'yes' : 'no'
      });
      else showBanner();
      return;
    }

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error || !window.Shopify.customerPrivacy) {
          if (!getFallbackConsent()) showBanner();
          return;
        }

        api = window.Shopify.customerPrivacy;
        var storedConsent = getFallbackConsent();
        if (storedConsent) {
          setCheckboxes({
            preferences: storedConsent.preferences ? 'yes' : 'no',
            analytics: storedConsent.analytics ? 'yes' : 'no',
            marketing: storedConsent.marketing ? 'yes' : 'no'
          });
          hideBanner();
          return;
        }

        setCheckboxes(api.currentVisitorConsent ? api.currentVisitorConsent() : null);

        if (typeof api.shouldShowBanner === 'function' && api.shouldShowBanner()) {
          showBanner();
        }
      }
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    banner = document.querySelector('[data-cookie-banner]');
    if (!banner) return;

    options = banner.querySelector('[data-cookie-options]');
    customizeButton = banner.querySelector('[data-cookie-customize]');
    acceptButton = banner.querySelector('[data-cookie-accept]');
    rejectButton = banner.querySelector('[data-cookie-reject]');
    saveButton = banner.querySelector('[data-cookie-save]');

    customizeButton.addEventListener('click', openPreferences);
    acceptButton.addEventListener('click', function () {
      saveConsent({ preferences: true, analytics: true, marketing: true });
    });
    rejectButton.addEventListener('click', function () {
      saveConsent({ preferences: false, analytics: false, marketing: false });
    });
    saveButton.addEventListener('click', function () {
      saveConsent({
        preferences: Boolean(banner.querySelector('[data-consent-preferences]').checked),
        analytics: Boolean(banner.querySelector('[data-consent-analytics]').checked),
        marketing: Boolean(banner.querySelector('[data-consent-marketing]').checked)
      });
    });

    document.querySelectorAll('[data-cookie-preferences-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (api && api.currentVisitorConsent) setCheckboxes(api.currentVisitorConsent());
        else {
          var fallbackConsent = getFallbackConsent();
          if (fallbackConsent) setCheckboxes({
            preferences: fallbackConsent.preferences ? 'yes' : 'no',
            analytics: fallbackConsent.analytics ? 'yes' : 'no',
            marketing: fallbackConsent.marketing ? 'yes' : 'no'
          });
        }
        openPreferences();
      });
    });

    initialiseApi();
  });
})();


/* Daily Bear: one Shopify-managed consent interface, 2026-11-02. */
(function () {
  'use strict';
  var nativeScript = document.querySelector('script[src*="shopifycloud/privacy-banner/"]');
  var root = document.documentElement;
  var style = document.createElement('style');
  style.id = 'dailybear-single-consent-style';
  style.textContent = [
    'html.db-native-consent [data-cookie-banner]{display:none!important}',
    '#shopify-pc__banner__btn-accept,[data-cookie-accept],[data-cookie-save]{background:#6D28D9!important;color:#fff!important;border:1px solid #6D28D9!important;border-radius:10px!important;font-weight:700!important}',
    '#shopify-pc__banner__btn-accept:hover,[data-cookie-accept]:hover,[data-cookie-save]:hover{background:#5B21B6!important;border-color:#5B21B6!important}',
    '#shopify-pc__banner button:focus-visible,[data-cookie-banner] button:focus-visible{outline:3px solid #A78BFA!important;outline-offset:3px!important}',
    '#shopify-pc__banner{border-radius:16px!important;box-shadow:0 8px 32px #24103826!important}'
  ].join('\n');
  document.head.appendChild(style);
  if (!nativeScript) return;

  root.classList.add('db-native-consent');
  function nativeReady() {
    return window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function';
  }
  function hideLegacy() {
    var banner = document.querySelector('[data-cookie-banner]');
    if (banner) banner.hidden = true;
  }
  function fallback(button) {
    root.classList.remove('db-native-consent');
    if (button) {
      button.dataset.dbConsentFallback = 'true';
      button.click();
      delete button.dataset.dbConsentFallback;
    }
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-cookie-preferences-open]');
    if (!button || button.dataset.dbConsentFallback === 'true') return;
    if (!nativeReady()) {
      root.classList.remove('db-native-consent');
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    root.classList.add('db-native-consent');
    hideLegacy();
    try {
      Promise.resolve(window.privacyBanner.showPreferences()).catch(function () { fallback(button); });
    } catch (error) { fallback(button); }
  }, true);
  document.addEventListener('DOMContentLoaded', hideLegacy);
  document.addEventListener('visitorConsentCollected', hideLegacy);
  hideLegacy();
  var attempts = 0;
  var timer = window.setInterval(function () {
    if (nativeReady()) {
      window.clearInterval(timer);
      hideLegacy();
    } else if (++attempts >= 100) {
      window.clearInterval(timer);
      root.classList.remove('db-native-consent');
    }
  }, 100);
})();
